<template>
  <label :for="id" class="tw-flex tw-cursor-pointer tw-items-center">
    <div class="tw-relative">
      <input
        type="checkbox"
        class="tw-sr-only"
        v-model="computedValue"
        :id="id"
        :name="name"
        :disabled="disabled"
        :value="value"
        :checked="checked"
      />
      <div class="tw-block tw-h-6 tw-w-10 tw-rounded-full tw-border tw-border-gray-500"></div>
      <div class="dot tw-absolute tw-left-1 tw-top-1 tw-h-4 tw-w-4 tw-rounded-full tw-bg-gray-300 tw-transition"></div>
    </div>
    <div class="tw-ml-2 tw-font-medium tw-text-gray-600"><slot></slot></div>
  </label>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  color: String,
  modelValue: [Boolean, String, Number, Array],
  value: [String, Number, Array],
  checked: Boolean,
  id: String,
  name: String,
  disabled: Boolean,
});

const emit = defineEmits(['update:modelValue']);

const computedValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});
</script>

<style scoped>
input:checked ~ .dot {
  transform: translateX(100%);
  background-color: v-bind(color) !important;
}
</style>
